<template>
	<div id="main-menu" v-show="isOpen" ref="main-menu">
		<span id="menu-overlay" @click="close()"></span>
		<transition name="fade">
			<div id="menu-wrapper" v-show="isOpen" ref="menu-wrapper">
				<header id="menu-header">
					<span id="menu-close" class="link-icon" tabindex="0" @click="close()">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="A" d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"/><path class="B" d="M0 0h24v24H0z"/></svg>
					</span>
					<div class="container">
						<div class="content">
							<router-link to="/" id="logo">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60"><path class="A" d="M104.18 30a30 30 0 0 0 30 30h126.5a8 8 0 0 0 6.39-3.58l32.36-52.84s2.2-3.58-2-3.58H134.18a30 30 0 0 0-30 30"/><path class="B" d="M158.5 27.7h-22.37l-4.6 4.6h10.87a8.88 8.88 0 1 1-2.3-8.58l3.25-3.25a13.49 13.49 0 1 0 3.75 11.84h6.66a20.08 20.08 0 1 1-5.76-16.5l3.25-3.25A24.671 24.671 0 1 0 158.49 30zm71.15 16.52c0 3-1.25 4.77-3.9 4.77h-3.82V32.77h3.82c2.64 0 3.9 1.9 3.9 4.92zM229 22.56c0 3-1.32 4.92-4 4.92h-3.16V17c0-3.38 1.25-4.92 3.6-4.92S229 13.6 229 17zm7 21.8v-7c0-3.67-1.62-6.54-4.26-7.64a7.77 7.77 0 0 0 3.67-6.9v-6.22c0-6.54-3.52-10.28-9.84-10.28s-9.9 3.75-9.9 10.28v38.2h10.13c7.2 0 10.2-4.1 10.2-10.43m-34.64-13.5H194V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.32 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2H194V36.6h7.34v18.2zm-25.2 0v-5.88H177c-2.64 0-3.9-1.84-3.9-4.85V6.92h-6.32v37.45c0 6.32 2.8 10.43 10.06 10.43z"/><path class="C" d="M95.84 54.8V16.6c0-6.54-3.9-10.28-10-10.28s-10 3.75-10 10.28v38.2h6.32V17c0-3.16 1.47-4.92 3.67-4.92s3.67 1.7 3.67 4.92v37.8zM64.26 23.5c0 3-1.25 4.92-3.9 4.92h-3.45V17c0-3.38 1.4-4.92 3.75-4.92s3.6 1.54 3.6 4.92zm6.3 31.3V38.64c0-3.67-1.32-6.83-4-7.93a8 8 0 0 0 4-7.2v-7c0-6.54-3.6-10.28-9.9-10.28S50.6 10.07 50.6 16.6v38.2h6.32V33.72h3.45c2.64 0 3.9 1.9 3.9 4.92V54.8zm-32-23.94H31.2V17c0-3.16 1.32-4.92 3.67-4.92s3.67 1.7 3.67 4.92zm6.3 23.94V16.6c0-6.32-3.67-10.28-10-10.28s-10 4-10 10.28v38.2h6.32V36.6h7.34v18.2zm-24.6-28.27V6.92H14v19.24c0 3.38-1.47 4.92-3.82 4.92s-3.82-1.54-3.82-4.92V6.92H0v19.6c0 5.36 2.57 8.9 7.05 9.9V54.8h6.32V36.44c4.33-1 7-4.55 7-9.9"/></svg>
							</router-link>
							<p class="sub-title">
								{{$t('app-subtitle1')}}<br>
								{{$t('app-subtitle2')}}<br>
								{{$t('app-subtitle3')}}
							</p>
							<p class="credits">{{$t('produced-by')}}&nbsp;<router-link :to="{name: 'about-us'}" class="credits-link">{{$t('gualchieri-e-gualchieri')}}</router-link></p>
						</div>
					</div>
				</header>
				<section id="menu-content">
					<div class="container">
						<div class="content">
							<ul class="menu-items menu-primary">
								<li class="menu-item">
									<router-link to="/yarn-count-converter">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
										{{$t('yarn-count-converter')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link to="/calculations">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 100"><path d="M32.5 100C14.58 100 0 85.2 0 67s14.58-33 32.5-33a32.14 32.14 0 0 1 5.63.49V0H65v66.26q0 .4 0 .77C65 85.2 50.42 100 32.5 100zm0-61.94C16.8 38.06 4 51.06 4 67s12.8 29 28.5 29S61 83 61 67 48.2 38.06 32.5 38.06zm9.63-2.52A32.77 32.77 0 0 1 61 51.2V36.52h-7.15v-4H61v-3.75H47v-4h14V21h-7.15v-4H61v-3.7H47v-4h14V4H42.13zM32.5 93a26 26 0 0 1 0-52 26 26 0 0 1 0 52zm0-48a22 22 0 0 0 0 44 22 22 0 0 0 0-44zm0 41a19 19 0 1 1 18.77-19A18.93 18.93 0 0 1 32.5 86.06zm0-34a15 15 0 1 0 14.77 15A14.92 14.92 0 0 0 32.5 52z"/><path d="M27.16 63.58a2 2 0 0 1-2-2v-3.06c0-7.7 6.3-9.74 9.62-9.74h2.73a2 2 0 0 1 0 4H34.8a5.39 5.39 0 0 0-5.62 5.74v3.07a2 2 0 0 1-2.01 1.99z"/></svg>
										{{$t('calculations')}}
									</router-link>
									<input type="checkbox" id="calcolo-metrico-checkbox" class="menu-item-checkbox">
									<label for="calcolo-metrico-checkbox" id="calcolo-metrico-label" class="menu-item-label">
										<svg class="dropdown-icon link-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg>
									</label>
									<ul class="menu-items">
										<li class="menu-item">
											<router-link to="/calculations/calculate-twists">
												{{$t('calculate-twists')}}
											</router-link>
										</li>
										<li class="menu-item">
											<router-link to="/calculations/measure-yarn-count">
												{{$t('measure-yarn-count')}}
											</router-link>
										</li>
										<li class="menu-item">
											<router-link to="/calculations/needles-heads">
												{{$t('needles-heads')}}
											</router-link>
										</li>
										<li class="menu-item">
											<router-link to="/calculations/calculate-production-kgh">
												{{$t('calculate-production-kgh')}}
											</router-link>
										</li>
										<li class="menu-item">
											<router-link to="/calculations/calculate-roving-bobbins-steering">
												{{$t('calculate-roving-bobbins-steering')}}
											</router-link>
										</li>
									</ul>
								</li>
								<li class="menu-item">
									<router-link to="/yarn-creation">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 100"><path d="M44.4 10h-22a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-20-4h18V4h-18zm27 94h-36a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-34-4h32v-2h-32z"/><path d="M57.9 94H9.1a9 9 0 0 1-9-9.85l6.45-67.3A12 12 0 0 1 18.5 6H50a12 12 0 0 1 12 11.15l4.8 67.2a9 9 0 0 1-9 9.64zM18.5 10a8 8 0 0 0-8 7.24l-6.37 67.3a5 5 0 0 0 5 5.47H57.9a5 5 0 0 0 5-5.36l-4.8-67.2a8 8 0 0 0-8-7.43z"/><path d="M60.2 24.85A17 17 0 0 1 45.41 8h4a13 13 0 0 0 11.32 12.89zM61.1 35A27 27 0 0 1 35.41 8h4a23 23 0 0 0 21.88 23zm.8 10A37.13 37.13 0 0 1 25.41 8h4a33.12 33.12 0 0 0 32.53 33zm.74 10h-.2a47.06 47.06 0 0 1-47-46.94h4a43.06 43.06 0 0 0 43 42.94h.2zm-.2 10a57 57 0 0 1-56-46.14l3.93-.76a53 53 0 0 0 52 42.9h.86l.13 4zm0 10A67.27 67.27 0 0 1 4.56 41.81l3.45-2A63.25 63.25 0 0 0 62.41 71H64l.07 4z"/><path d="M4.53 63.86L4 60a12.9 12.9 0 0 0 10.11-7.3l3.6 1.72a16.88 16.88 0 0 1-13.19 9.54zM3.4 74l-.14-4A22.92 22.92 0 0 0 22 59.12l3.4 2.1A26.91 26.91 0 0 1 3.39 74zM2.4 84v-4a32.84 32.84 0 0 0 28-15.55l3.4 2.12A36.82 36.82 0 0 1 2.41 84zm5.05 9.73l-.42-4a43.14 43.14 0 0 0 32.61-21.22l3.46 2A47.15 47.15 0 0 1 7.46 93.73zm27.72-.1l-2.3-3.27A53.26 53.26 0 0 0 49.6 71.16L53.16 73a57.27 57.27 0 0 1-17.98 20.64zm26.55-25.06v-.01h4l-4 .01zm-11 24.8l-2.88-2.77a62.57 62.57 0 0 0 12.31-18.43l3.67 1.6a66.55 66.55 0 0 1-13.1 19.6z"/></svg>
										{{$t('yarn-creation')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'yarns'}">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 3H5C3.88 3 3 3.9 3 5V19a1.99 1.99 0 0 0 1.99 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"/></svg>
										{{$t('yarns-archive')}}
									</router-link>
									<input type="checkbox" id="yarns-checkbox" class="menu-item-checkbox">
									<label for="yarns-checkbox" id="yarns-label" class="menu-item-label">
										<svg class="dropdown-icon link-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg>
									</label>
									<ul class="menu-items">
										<li
											v-for="(yarn, index) in yarns"
											:key="'yarn-' + index"
											class="menu-item"
										>
											<router-link :to="{name: 'yarn', params: {id: yarn.id, type: yarn.saved}}">
												{{yarn.data.yarnName}}
											</router-link>
										</li>
									</ul>
								</li>
							</ul>
							<div class="boxed">
								<span class="title boxed-title customer-area" v-if="userLogged">
									<router-link :to="{name: 'account'}">{{username}}</router-link>
									<a href="#" @click.prevent="logout">{{$t('exit')}}</a>
								</span>
								<span class="title boxed-title customer-area" v-else>
									{{$t('customers-area')}}
									<router-link :to="{name: 'login'}">{{$t('enter')}}</router-link>
								</span>
								<ul class="menu-items boxed-item">
									<li class="menu-item">
										<router-link :to="{name: 'machines'}">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="menu-item-icon"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"></path></svg>
											{{$t('machines')}}
										</router-link>
									</li>
									<li class="menu-item">
										<router-link :to="{name: 'remote-control-machines'}">
											<svg class="menu-item-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M88,82H12A12,12,0,0,1,0,70V12A12,12,0,0,1,12,0H88a12,12,0,0,1,12,12V70A12,12,0,0,1,88,82ZM12,4a8,8,0,0,0-8,8V70a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V12a8,8,0,0,0-8-8Z"/><path d="M0 62h96v4H0zm48 18h4v20h-4z"/><path d="M70 100H30a2 2 0 0 1 0-4h40a2 2 0 0 1 0 4zM50 48a2 2 0 0 1-1.41-.59 1.41 1.41 0 0 1-.25-.3 2.28 2.28 0 0 1-.19-.34 2.66 2.66 0 0 1-.11-.38 1.92 1.92 0 0 1 0-.78 2.22 2.22 0 0 1 .11-.37 2 2 0 0 1 .19-.35 1.41 1.41 0 0 1 .25-.3 2.06 2.06 0 0 1 2.83 0 1.75 1.75 0 0 1 .24.3 1.48 1.48 0 0 1 .19.35 1.57 1.57 0 0 1 .11.37 1.92 1.92 0 0 1 0 .78 1.8 1.8 0 0 1-.11.38 1.63 1.63 0 0 1-.19.34 1.75 1.75 0 0 1-.24.3A2 2 0 0 1 50 48zm10-10a2 2 0 0 1-1.41-.59 12 12 0 0 0-17 0 2 2 0 0 1-2.83-2.83 16 16 0 0 1 22.63 0 2 2 0 0 1-1.39 3.42zm8.48-8.48A2 2 0 0 1 67 29a24 24 0 0 0-34 0 2 2 0 1 1-2.8-2.8 28 28 0 0 1 39.6 0 2 2 0 0 1-1.41 3.41z"/></svg>
											{{$t('remote-control')}}
										</router-link>
									</li>
									<li class="menu-item">
										<router-link :to="{name: 'production-control'}">
											<svg class="menu-item-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M88 100H12A12 12 0 0 1 0 88V12A12 12 0 0 1 12 0h76a12 12 0 0 1 12 12v76a12 12 0 0 1-12 12zM12 4a8 8 0 0 0-8 8v76a8 8 0 0 0 8 8h76a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zm38 78a2 2 0 0 1-2-2V38a2 2 0 0 1 4 0v42a2 2 0 0 1-2 2zm-24 0a2 2 0 0 1-2-2V70a2 2 0 0 1 4 0v10a2 2 0 0 1-2 2zm0-34a2 2 0 0 1-2-2V20a2 2 0 0 1 4 0v26a2 2 0 0 1-2 2zm48 16a2 2 0 0 1-2-2V20a2 2 0 0 1 4 0v42a2 2 0 0 1-2 2zm-48 2a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm24-20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm24 60a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"/></svg>
											{{$t('production-control')}}
										</router-link>
									</li>
									<li class="menu-item">
										<router-link :to="{name: 'machines-documents'}">
											<svg class="menu-item-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100"><path d="M60 92a2 2 0 0 1-1-.29L56 90a28 28 0 0 0-14.41-4H10a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h40a12 12 0 0 1 12 12v78a2 2 0 0 1-2 2zM12 82h29.7A32 32 0 0 1 58 86.47V12a8 8 0 0 0-8-8H12z"/><path d="M60 92a2 2 0 0 1-2-2V12A12 12 0 0 1 70 0h40a2 2 0 0 1 2 2v82a2 2 0 0 1-2 2H78.3a28 28 0 0 0-14.41 4l-3 1.7a2 2 0 0 1-1 .29zM70 4a8 8 0 0 0-8 8v74.47A32 32 0 0 1 78.31 82H108V4z"/><path d="M60 100a2 2 0 0 1-2-2v-8a2 2 0 0 1 4 0v4.47A32 32 0 0 1 78.31 90H116V12h-6a2 2 0 0 1 0-4h8a2 2 0 0 1 2 2v82a2 2 0 0 1-2 2H78.3a28 28 0 0 0-14.41 4l-3 1.7a2 2 0 0 1-1 .29z"/><path d="M60 100a2 2 0 0 1-1-.29L56 98a28 28 0 0 0-14.41-4H2a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h8a2 2 0 0 1 0 4H4v78h37.7A32 32 0 0 1 58 94.47V90a2 2 0 0 1 4 0v8a2 2 0 0 1-2 2zm42-82H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zM52 18H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm16-44a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 26z"/><path d="M76 26a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 26zm-8 22a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 48z"/><path d="M76 48a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 48zm-8 22a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 70z"/><path d="M76 70a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 70zm-54 0a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 70zm0-44a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 26zm0 22a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 48z"/></svg>
											{{$t('machines-documents')}}
										</router-link>
									</li>
								</ul>
							</div>
							<ul class="menu-items">
								<li class="menu-item">
									<router-link to="/customer-area/account">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 100"><path d="M74 100H2a2 2 0 0 1-2-2V82a37.39 37.39 0 0 1 27.27-35.69 24.4 24.4 0 1 1 21.47 0A37.39 37.39 0 0 1 76 82v16a2 2 0 0 1-2 2zM4 96h68V82c0-18.3-15.25-33.2-34-33.2S4 63.7 4 82zM38 4a20.4 20.4 0 1 0 20.4 20.4A20.42 20.42 0 0 0 38 4z"/></svg>
										{{$t('account')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link to="/settings">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M578 980.7H420.6L395 823c-16.5-5.4-32.7-12.2-48.2-20l-131 95.4L104.4 787l95.3-131c-8-16-15-32.4-20.5-49.3l-160-25.2V424l160-25.2c5.6-17.2 12.6-34 21-50.3l-96.5-132.6L215 104.4l133.4 97c15-7.5 30.5-14 46.4-19.2l25.6-163H578L603.6 182c16.6 5.4 33 12 48.7 20l132-95 111.3 111.3-95 131.8c7.8 15.3 14.4 31.3 19.8 47.6l160.3 26v157.5l-160.3 26c-5.2 16-11.7 31.6-19.2 46.6L895 784.2 783.6 895.6l-129.4-93.2c-16.3 8.4-33.2 15.4-50.5 21L578 980.7zm-148-11h138.7L594 815l3.3-1c18.8-6 37.3-13.6 55-23l3-1.6L782.4 881l98-98-89.2-124-3.2-3.2 1.8-3.6c8.6-16.6 15.7-34 21.3-51.7l1.2-4h6L969.7 572V433.3l-151-24.6h-6.5l-1.2-4c-5.7-18.2-13-36-22-53l-2-3.6 4.3-4.3L881 219.5l-98-98-124 89.3-4.6 4.6-3.6-2c-17.2-9-35.3-16.5-53.6-22.2l-3.3-1-25.2-160H430L405.5 187v3.6l-3.8 1.2c-17.5 5.5-34.7 12.7-51 21l-3.6 2-2.8-2.8-128-93-98 98 95 130.5-1.6 3c-9.3 17.5-17 36-22.8 54.8l-1 3.3-157.5 24.7V572l157.4 24.8 1 3.3c5.8 18.4 13.3 36.5 22.3 53.8l1.6 3-93.8 129 98 98 129-93.8 3 1.6c17 9 34.6 16.3 52.7 22l4 1.2v3.6L430 969.7z"/><path d="M586 990H412.7l-26-160c-13.2-4.6-26.4-10-39-16.3l-132.8 96.7L92.2 788 189 655c-6.4-13-12-26.5-16.6-40.2L10 589.3V416l162.3-25.6c4.8-14 10.5-27.8 17.2-41.2l-98-134.4L214 92.2l135.3 98.4c12-5.8 24.6-11 37.2-15.4l26-165.3H586l26 164.8c13.4 4.6 26.7 10 39.6 16.3l133.7-96.2 122.4 122.4L811.4 351c6 12.5 11.5 25.4 16 38.5L990 416v173.2l-162.6 26.5c-4.4 12.7-9.6 25.3-15.5 37.5l95 132-122.4 122.4-131.2-94.5C640 820 626 825.7 612 830.5L586 990zm-148-29.6h123l25-152.6 8.8-2.7c18.3-5.7 36.2-13.2 53.4-22.2l8-4.2L781.6 869l87-87-87-120-4.8-4.8 5-9.6c8.3-16 15.3-33 20.7-50.3l3.2-10.4h12.8l142-23.2V441.2L817.2 418H805.4l-3.3-10.4c-5.5-17.7-12.7-35-21.3-51.4l-5-9.6 9-9 84-117-87-87L661 222 656 227l-9.6-5c-16.7-8.8-34.3-16-52-21.6l-8.8-2.7-25-158H438l-23.4 148.8.1 9-10.3 3.3c-17 5.4-33.7 12.3-49.6 20.5l-9.6 5-7.6-7.6L217.2 131l-86.8 86.8 93.8 128.8-4.3 8c-9 17-16.5 35-22.2 53.2l-2.7 8.8-155.4 24.5V564L195 588.4l2.7 8.8c5.6 18 13 35.5 21.7 52.3l4.3 8L131 784.8l86.8 86.8L345 779l8 4.2c16.4 8.6 33.6 15.8 51.2 21.4l10.3 3.3v10.4l23.3 142zm61.5-260c-109.7 0-199-89.2-199-199s89.2-199 199-199 199 89.2 199 199c.1 109.6-89.2 199-199 199zm0-387c-103.6 0-188 84.3-188 188s84.3 188 188 188 188-84.3 188-188-84.3-188-188-188zm0 396c-114.8 0-208.2-93.4-208.2-208.2s93.4-208.2 208.2-208.2 208.2 93.4 208.2 208.2-93.4 208.2-208.2 208.2zm0-386.8c-98.5 0-178.6 80-178.6 178.6S401 680 499.4 680 678 600 678 501.5C678 403 598 323 499.4 323z"/></svg>
										{{$t('settings')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'about-us'}">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M98 100H50a50 50 0 1 1 50-50v48a2 2 0 0 1-2 2zM50 4a46 46 0 0 0 0 92h46V50A46.05 46.05 0 0 0 50 4zm0 33a3 3 0 0 1-2.12-.88 2.78 2.78 0 0 1-.37-.46 3.15 3.15 0 0 1-.28-.51 3.51 3.51 0 0 1-.17-.56 2.93 2.93 0 0 1 0-1.18 2.76 2.76 0 0 1 .17-.56 3.65 3.65 0 0 1 .27-.52 3.19 3.19 0 0 1 .38-.45 3.09 3.09 0 0 1 4.24 0 3.22 3.22 0 0 1 .38.45 3.75 3.75 0 0 1 .27.52 2.82 2.82 0 0 1 .17.56 2.93 2.93 0 0 1 0 1.18 3.61 3.61 0 0 1-.17.56 3.15 3.15 0 0 1-.28.51 2.78 2.78 0 0 1-.37.46A3 3 0 0 1 50 37zm0 32a3 3 0 0 1-3-3V46a3 3 0 0 1 6 0v20a3 3 0 0 1-3 3z"/></svg>
										{{$t('about-us')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'contacts'}">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100"><path d="M108 100H12A12 12 0 0 1 0 88V12A12 12 0 0 1 12 0h96a12 12 0 0 1 12 12v76a12 12 0 0 1-12 12zM12 4a8 8 0 0 0-8 8v76a8 8 0 0 0 8 8h96a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8z"/><path d="M60 57.55a22 22 0 0 1-14.36-5.3L.7 13.5a2 2 0 0 1 2.61-3l44.95 38.72a18.11 18.11 0 0 0 23.51 0L116.7 10.5a2 2 0 0 1 2.61 3L74.36 52.26A22 22 0 0 1 60 57.55z"/><path d="M118 88a2 2 0 0 1-1.52-.7l-36-42a2 2 0 0 1 3-2.6l36 42A2 2 0 0 1 118 88zM2 88a2 2 0 0 1-1.52-3.3l36-42a2 2 0 0 1 3 2.6l-36 42A2 2 0 0 1 2 88z"/></svg>
										{{$t('contacts')}}
									</router-link>
								</li>
							</ul>
							<div class="info">{{currentYear}} &copy; hivetechnology.net <span class="version">{{version}}</span></div>
						</div>
					</div>
				</section>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: 'MainMenu',
	methods: {
		close() {
			this.$store.dispatch('closeMenu');
		},
		logout () {
			var self = this;
			this.$store.dispatch('authLogout')
			.then(() => {
				self.$router.push({name: 'login'});
			});
		},
	},
	computed: {
		...mapState(['app']),
		isOpen() {
			return this.$store.getters.isMenuOpen;
		},
		currentYear() {
			return (new Date()).getFullYear();
		},
		yarns() {
			return ([...this.app.yarnsArchive]).sort((a,b) => (a.timestamp > b.timestamp ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0))).slice(0, 5);
		},
		username() {
			return this.$store.getters.getProfile.name;
		},
		userLogged() {
			return this.$store.getters.isAuthenticated;
		},
		version() {
			return `${process.env.VUE_APP_VERSION}`;
		}
	},
	watch: {
		isOpen(newValue) {
			let scrollParent = getScrollParent(this.$refs['main-menu']);
			let top = 0;
			if (scrollParent) {
				scrollParent.style.overflow = newValue?'hidden':'auto';
				top = scrollParent.scrollTop;
			}
			this.$refs['menu-wrapper'].scrollTop = 0;
			this.$refs['menu-wrapper'].style.top = top + 'px';
		},
		$route() { //to, from) {
			if (this.isOpen) {
				this.$store.dispatch('closeMenu');
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main-menu #menu-overlay {
	position: fixed;
	display: block;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 200;
}

#main-menu #menu-wrapper {
	position: absolute;
	top: 0;
	right: 0;
	width: 36.0rem;
	max-width: 100%;
	height: 100%;
	background-color: #fff;
	z-index: -1;
	box-shadow: /*-4.0rem 0 0 0 rgba(0,0,0,0.2),*/
	0 0 0.4rem rgba(0,0,0,0.5);
	overflow: auto;
	color: var(--primary_text_color);
	z-index: 300;
	transition: opacity .2s ease-in-out;
}

#main-menu #menu-header {
	background-color: var(--primary_color_darker);
	color: var(--inverse_text_color);
	padding: 7.2rem 0 1.6rem 0;
}

#main-menu #menu-header .link-icon {
	width: 4.0rem;
	height: 4.0rem;
}

#main-menu #menu-header path {
	fill: var(--inverse_text_color);
}

#main-menu #menu-close {
	position: absolute;
	top: 1.6rem;
	right: 2.0rem;
	z-index: 30;
	color: var(--inverse_text_color);
}

#main-menu #menu-close svg {
	width: 100%;
	height: 100%;
}

#main-menu #menu-close .B {
	fill: none;
}

#main-menu #menu-header #logo {
	display: flex;
	color: var(--inverse_text_color);
}

#main-menu #menu-header #logo svg {
	width: auto;
	height: 8.0rem;
}

/*#main-menu #menu-header #logo .A {
	fill: var(--inverse_text_color);
}*/

#main-menu #menu-header #logo .B {
	fill: var(--primary_color);
}

/*#main-menu #menu-header #logo .C {
	fill: var(--inverse_text_color);
}*/

#main-menu #menu-header .sub-title {
	font-family: 'Charlet Comprime';
	font-size: 3.2rem;
	line-height: 3.2rem;
	font-weight: 500;
	padding: 2.4rem 0 4.0rem 0;
	margin-bottom: 0;
}

#main-menu #menu-content {
	padding-top: 2.4rem;
}

#main-menu #menu-content path {
	fill: var(--primary_text_color);
}

#main-menu #menu-content .primary path {
	fill: var(--primary_color);
}

#main-menu #menu-content .menu-items {
	flex-basis: 100%;
	list-style: none;
	margin: 0 0 2.4rem 0;
}

#main-menu #menu-content .menu-items .menu-item {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: .8rem;
	overflow: hidden;
}

#main-menu #menu-content .menu-items .menu-item a {
	display: flex;
	font-size: 2.0rem;
	line-height: 4.0rem;
	color: var(--primary_text_color);
}

#main-menu #menu-content .menu-items.menu-primary .menu-item,
#main-menu #menu-content .menu-items.menu-primary .menu-item a {
	color: var(--primary_color_darker);
}

#main-menu #menu-content .menu-items .menu-item .menu-item-icon {
	display: block;
	width: 4.0rem;
	height: 4.0rem;
	margin-right: 1.6rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-icon.small {
	padding: .4rem;
}

#main-menu #menu-content .title {
	display: block;
	text-align: center;
	font-size: 1.8rem;
	margin-bottom: 1.6rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-label {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 0;
	margin-left: .8rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox {
	display: none;
}

#main-menu #menu-content .menu-items .menu-item .menu-items {
	max-height: 0;
	position: absolute;
	margin-bottom: 0;
	padding: 1.6rem;
	border-left: .3rem solid var(--primary_color_darker);
	opacity: 0;
	pointer-events: none;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox:checked ~ .menu-items {
	max-height: 500px;
	position: inherit;
	opacity: 1;
	pointer-events: auto;
	transition: opacity .2s ease-in-out, max-height .5s ease-in-out;
}

#main-menu #menu-content .menu-items .menu-item .dropdown-icon {
	width: 2.0rem;
	height: 2.0rem;
	transform: rotate(270deg);
	transition: transform .2s ease-in-out;
}

#main-menu #menu-content .menu-items .menu-item .dropdown-icon.link-icon {
	width: 4.0rem;
	height: 4.0rem;
	padding: .8rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox:checked ~ .menu-item-label .dropdown-icon {
	transform: rotate(90deg);
}

#main-menu .credits {
	position: absolute;
	bottom: 0;
	margin-bottom: 0;
	font-size: 1.8rem;
}

#main-menu .credits .credits-link {
	background: var(--inverse_text_color);
	color: var(--primary_color);
	border-radius: .3rem;
	padding: 0 .3rem;
}

#main-menu .info {
	display: flex;
	justify-content: space-between;
	margin-bottom: .8rem;
}

#main-menu #menu-content .boxed .boxed-title {
	background: #ddd;
	border-radius: .3rem;
	padding: 0 .8rem;
	margin-bottom: 0;
}

#main-menu #menu-content .boxed .boxed-title.customer-area {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#main-menu #menu-content .boxed .boxed-item {
	background: #ececec;
	padding: 1.6rem 0.8rem 0.8rem 0.8rem;
	border-radius: .3rem;
}
</style>
